import * as React from "react";

import { cn } from "@/lib/utils";

const shellClassName =
  "block w-fit rounded-full border border-[#D6D6DE] bg-white py-4 px-9";

const interactiveClassName =
  "transition-colors hover:border-[#939399] disabled:cursor-not-allowed disabled:opacity-50";

/** 원티드·유사 화면용 회색 테두리 pill 라벨 타이포 */
export const softPillButtonLabelClassName =
  "font-pretendard text-[16px] font-semibold";

export type SoftPillButtonProps = React.ComponentProps<"button"> & {
  /**
   * `interactive`: 호버·disabled 스타일 (초기화 등)
   * `default`: 셸만 (현황 보기 등)
   */
  pillVariant?: "default" | "interactive";
};

export function SoftPillButton({
  className,
  pillVariant = "default",
  type = "button",
  ...props
}: SoftPillButtonProps) {
  return (
    <button
      type={type}
      className={cn(
        shellClassName,
        pillVariant === "interactive" && interactiveClassName,
        className
      )}
      {...props}
    />
  );
}
